import ReactDOM from 'react-dom/client';

import store from './store/Store';
import App from './App';
import React from 'react';
import { Provider } from 'react-redux';
import ViewportProvider from './helper/customHooks/ViewportProvider';
import { UIKitSettingsBuilder } from '@cometchat/uikit-shared';
import { CometChatConstants } from './cometchat/constants';
import { CometChatUIKit } from '@cometchat/chat-uikit-react';

(async () => {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(CometChatConstants.appId as string)
    .setRegion(CometChatConstants.region as string)
    .setAuthKey(CometChatConstants.authKey as string)
    .subscribePresenceForFriends()
    .build();
  try {
    await CometChatUIKit.init(uiKitSettings);
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
      <React.StrictMode>
        <ViewportProvider>
          <Provider store={store}>
            <App />
          </Provider>
        </ViewportProvider>
      </React.StrictMode>
    );
    askPermission();
  } catch (error) {
    console.warn('Initialization failed with error:', error);
  }
})();

async function askPermission() {
  return new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result);
    });

    if (permissionResult) {
      permissionResult.then(resolve, reject);
    }
  }).then(function (permissionResult) {
    if (permissionResult !== 'granted') {
      // throw new Error("We weren't granted permission.");
      console.warn('permission not granted');
    }
  });
}
